module.exports = __webpack_public_path__ + "img/IMG_5068.7d4007a7.png";